import React,{useContext,useEffect, useState, useRef,useReducer, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { MultiSelect } from 'primereact/multiselect';
import { useTrainingCompanies } from '../../utils/useTrainingCompanies';
import {
    computeTrainingSelectionCascade,
    resolveTrainingSelectionDefaults,
    toTrainingSelectionFormValues,
} from '../../utils/trainingSelectionCascade';
import {
    keepRecordEmployeesForTraining,
    recordEmployeeOptions,
} from '../../utils/trainingEmployeeScope';
import { emitTrainingRecordListInvalidatingWrite } from '../../utils/trainingRecordListSync';
import { uiT as t } from '../../utils/uiTranslate';

export default function TrainingRecordAdd({training}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { trainingCompanies, loading: loadingCompanies } = useTrainingCompanies();
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView,setDialogText,setVisible} = useContext(UtilContext);
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);
    const fileListRef = useRef(null);

    const [formTraining,setFormTraining] = useState(training);
    const [trainingDepartment,setTrainingDepartment] = useState([]);
    const [trainings,setTrainings] = useState([]);
    const [allTrainingTypes, setAllTrainingTypes] = useState([]);

    const [lecturers, setLecturers] = useState([]);
    const [allCompanyContacts, setAllCompanyContacts] = useState([]);
    const [companyContacts, setCompanyContacts] = useState([]); // dropdown list (môže byť filtrovaný)
    const [trainingCards, setTrainingCards] = useState([]);
    const [trainingEmployees, setTrainingEmployees] = useState([]);
    const [machines, setMachines] = useState(state.machines || []);
    const [lecturersFallback, setLecturersFallback] = useState([]);
    const [companyContactsFallback, setCompanyContactsFallback] = useState([]);
    const effectiveLecturers = (state.lecturers || []).length ? (state.lecturers || []) : lecturersFallback;
    const effectiveCompanyContactsBase = (allCompanyContacts || []).length ? allCompanyContacts : ((state.company_contacts || []).length ? (state.company_contacts || []) : companyContactsFallback);

    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add training"))?false:true);

    const [fileList, setFileList] = useState([]);
    const [loadingData, setLoadingData] = useState(true);

    useEffect(() => {
        setLoadingData(true);
        getRequest("/api/trng012_data")
            .then((r) => {
                const d = r?.data ?? r;
                setTrainingCards(d?.training_cards || []);
                setTrainingEmployees(d?.training_employees || []);
                setAllCompanyContacts(d?.company_contacts || []);
                setCompanyContacts(d?.company_contacts || []);
                setAllTrainingTypes(d?.training_types || []);
                setTrainings(d?.training_types || []);
            })
            .catch(() => {})
            .finally(() => setLoadingData(false));
    }, []);

    useEffect(() => {
        if ((state.lecturers || []).length > 0 && lecturers.length === 0) setLecturers(state.lecturers || []);
        if ((state.machines || []).length > 0 && machines.length === 0) setMachines(state.machines || []);
    }, [state.lecturers, state.machines]);

    useEffect(() => {
        if ((state.lecturers || []).length > 0) return;
        getRequest("/api/lecturers").then((r) => { const list = r?.data ?? r ?? []; setLecturersFallback(Array.isArray(list) ? list : []); }).catch(() => {});
    }, [state.lecturers?.length]);
    useEffect(() => {
        if ((allCompanyContacts || []).length > 0 || (state.company_contacts || []).length > 0) return;
        getRequest("/api/company_contacts?minimal=1&module=training").then((r) => { const list = r?.data ?? r ?? []; setCompanyContactsFallback(Array.isArray(list) ? list : []); }).catch(() => {});
    }, [allCompanyContacts?.length, state.company_contacts?.length]);

    function addNewTraining(){
        dispatch({type:'create_new_tab',name: t('TrainingStateList.Text.Nove_skolenie'), translationKey: 'TrainingStateList.Text.Nove_skolenie', legacyLabel: t('TrainingStateList.Text.Nove_skolenie'),page:'TrainingRecordAdd',props:{training: null,type:'add'},mask:'trng012'});
    }
    function copyTraining(){
        dispatch({type:'create_new_tab',name: t('TrainingStateList.Text.Nove_skolenie'), translationKey: 'TrainingStateList.Text.Nove_skolenie', legacyLabel: t('TrainingStateList.Text.Nove_skolenie'),page:'TrainingRecordAdd',props:{training: formik.values,type:'add'},mask:'trng012'});
    }

    const validate = values => {
        const errors = {};
        if(!values.training_id){
            errors.training_id = t('Common.RequiredField');
        }
        else{
            let my_employees = values.employees.map(employee => employee.id);
            for (let i = 0; i < my_employees.length; i++) {
                const employeeId = my_employees[i];
                let card = trainingCards.filter(emp => emp.id == employeeId);
                if(card.length<1){
                    if(!errors?.employees)errors.employees = '';
                    errors.employees += t('Training.Error.NoCard', { name: (state.employees || []).find(emp => emp.id == employeeId)?.name });
                }
                    else{
                    let training = card[0].training_card.filter(card => card.employee_id == employeeId && card.training_id==values.training_id);
                    if(training.length<1){
                        if(!errors?.employees)errors.employees = '';
                        errors.employees += t('Training.Error.NoTraining', { name: (state.employees || []).find(emp => emp.id == employeeId)?.name });
                    }
                }
            }
        }
        if (values?.machines?.length<1) {
            errors.machines = t('Common.RequiredField');
        }
        return errors;
    };

    const formik = useFormik({
        initialValues: formTraining==null?{
            training_id: '',last_training_date: '',employees:[],description:'',company_id:'',machines:[],lecturer_id:'',company_contact_id:''}
            :formTraining,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if(value=="machines"){
                    formData.append("machines", values.machines.map(machine => machine.id));
                }
                else if(value=="employees"){
                    let my_employees = values.employees.map(employee => employee.id);
                    for (var i = 0; i < my_employees.length; i++) {
                        formData.append('employees[]', my_employees[i]);
                    }
                }
                else formData.append(value, values[value] != null ? values[value] : "");
            }
            /*for (var pair of formData.entries()) {
                console.log(pair[0]+ ', ' + pair[1]);
            }*/
            for(let i = 0;i<fileList.length;i++){
                //console.log("IMAGE :"+fileList[i].name);
                formData.append('files[]',fileList[i]);
            }
            setDialogText(t('Common.Saving'));
            setVisible(true);
            postRequest('/api/training_records', formData,true)
            .then((response) => {
                emitTrainingRecordListInvalidatingWrite({ operation: 'create' });
                if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                formik.resetForm();
                setTrainingDepartment("");
                setTrainings([]);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                setVisible(false);
            }).catch((reason) => {
                setVisible(false);
                alert(t('Common.Toast.ActionFailedDetail'));
            })
        },
    });

    function filterTrainings(departmentId){
        setTrainingDepartment(departmentId);
        if(departmentId==="") setTrainings(allTrainingTypes);
        else setTrainings(allTrainingTypes.filter(t => t.department?.id === parseInt(departmentId, 10)));
    }

    const handleFileChange = (event) => {
        setFileList(event.target.files);
    };

    const cascadeGenRef = useRef(0);
    const cascadeHydratedRef = useRef(false);

    function cascadeSnapshot(overrides) {
        return {
            companies: trainingCompanies,
            machines: state.machines || [],
            lecturerTypes: effectiveLecturers,
            companyContacts: effectiveCompanyContactsBase,
            ...overrides,
        };
    }

    function applyTrainingCascade(result, extraValues = {}) {
        const token = ++cascadeGenRef.current;
        setMachines(result.availableMachines);
        setLecturers(result.availableLecturerTypes);
        setCompanyContacts(result.availableContacts);
        if (token !== cascadeGenRef.current) return;
        const { employees: extraEmployees, ...restExtra } = extraValues;
        const trainingId = restExtra.training_id ?? formik.values?.training_id;
        const selectedSource = extraEmployees !== undefined ? extraEmployees : formik.values.employees;
        formik.setValues({
            ...formik.values,
            ...toTrainingSelectionFormValues(result),
            ...restExtra,
            employees: keepRecordEmployeesForTraining(selectedSource, trainingCards, trainingId, {
                companyId: result.companyId,
                machineIds: result.selectedMachineIds,
                lecturerTypeId: result.lecturerTypeId,
            }),
        });
    }

    function changeTraining(training_id){
        const training = allTrainingTypes.find(t => t.id == training_id);
        const defaults = resolveTrainingSelectionDefaults(training, {
            companyId: formik.values?.company_id,
            machineIds: formik.values?.machines,
        });
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            selectedTraining: training,
            companyId: defaults.companyId,
            machineIds: defaults.machineIds,
            lecturerTypeId: formik.values?.lecturer_id,
            companyContactId: formik.values?.company_contact_id,
        })), {
            training_id,
        });
    }

    function changeCompany(company_id){
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            companyId: company_id,
            machineIds: formik.values?.machines,
            lecturerTypeId: formik.values?.lecturer_id,
            companyContactId: formik.values?.company_contact_id,
        })));
    }

    function changeMachine(nextMachines){
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            companyId: formik.values?.company_id,
            machineIds: nextMachines,
            lecturerTypeId: formik.values?.lecturer_id,
            companyContactId: formik.values?.company_contact_id,
        })));
    }

    function changeLecturer(lecturer_id){
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            companyId: formik.values?.company_id,
            machineIds: formik.values?.machines,
            lecturerTypeId: lecturer_id,
            companyContactId: formik.values?.company_contact_id,
        })));
    }

    useEffect(() => {
        if (loadingData || cascadeHydratedRef.current) return;
        if (!formik.values?.training_id && !formik.values?.company_id) {
            cascadeHydratedRef.current = true;
            return;
        }
        cascadeHydratedRef.current = true;
        const training = allTrainingTypes.find(t => t.id == formik.values.training_id);
        const defaults = resolveTrainingSelectionDefaults(training, {
            companyId: formik.values.company_id,
            machineIds: formik.values.machines,
        });
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            selectedTraining: training,
            companyId: defaults.companyId,
            machineIds: formik.values.machines?.length ? formik.values.machines : defaults.machineIds,
            lecturerTypeId: formik.values.lecturer_id,
            companyContactId: formik.values.company_contact_id,
        })));
    }, [loadingData, allTrainingTypes, effectiveCompanyContactsBase, effectiveLecturers]);

    const machineSelectOptions = useMemo(() => {
        const base = (machines || []).map(m => ({ id: m.id, name: m.name }));
        const sel = formik.values?.machines || [];
        const missing = sel.filter(s => !base.some(b => b.id == (s?.id ?? s)));
        return [...base, ...missing.map(m => ({ id: m?.id ?? m, name: m?.name ?? `Stroj #${m?.id ?? m}` }))];
    }, [machines, formik.values?.machines]);

    const machineSelectValue = useMemo(() => {
        const opts = machineSelectOptions;
        const sel = formik.values?.machines || [];
        const byId = (arr, id) => arr.find(x => (x?.id ?? x) == id);
        return sel.map(m => byId(opts, m?.id ?? m) || { id: m?.id ?? m, name: m?.name ?? `Stroj #${m?.id ?? m}` }).filter(Boolean);
    }, [machineSelectOptions, formik.values?.machines]);

    return (
        <>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            {/*<div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>*/}
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTraining()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyTraining()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('Common.NewTrainingCompany'),"TrainingRecordAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("TrainingRecordAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        {loadingData ? (
        <div className="flex flex-col items-center justify-center h-[calc(100vh-177px)] bg-gray-100 gap-4">
            <InfinitySpin width="120" color="#333" />
            <span className="text-gray-700">{t('Common.LoadingEllipsis')}</span>
        </div>
        ) : (
        <div className='overflow-y-auto h-[calc(100vh-177px)] bg-gray-100'>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-white rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.ZAZNAMENAT_NOVE_SKOLENIE')}</h1>
                    <div>
                        <label
                            htmlFor="trainingDepartment"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.TrainingDepartment')}</label>
                        <select
                        name='trainingDepartment'
                        onChange={(e) => filterTrainings(e.target.value)} value={trainingDepartment}
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                          {(state.departments || []).map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                        </select>
                    </div>
                        <div>
                        <label
                            htmlFor="training_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('Common.TrainingName')}
                        </label>
                        <select
                        required
                        name="training_id"
                        onChange={(e) => changeTraining(e.target.value)} value={formik.values.training_id}
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('Ui.R67.Vyber_skolenie')}</option>
                          {trainings.map((training) => (
                            <option key={training.id} value={training.id}>{training.name}</option>
                            ))}
                        </select>
                        </div>
                      <div>
                        <label
                            htmlFor="last_training_date"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Datum_skolenia')}</label>
                        <input
                            name='last_training_date'
                            type="date" required
                            onChange={formik.handleChange} value={formik.values.last_training_date}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>
                        <div>
                            <label
                                htmlFor="company_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TrainingCompanyShort')}</label>
                            <select required
                            name='company_id'
                            onChange={(e) => changeCompany(e.target.value)} value={formik.values?.company_id}
                            disabled={loadingData || loadingCompanies}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{(loadingData || loadingCompanies) ? t('Common.LoadingEllipsis') : t('Common.SelectTrainingCompany')}</option>
                            {trainingCompanies.map((training_company) => (
                                <option key={training_company.id} value={training_company.id}>{training_company.name}</option>
                            ))}
                            </select>
                        </div>
                        {(formik.values?.company_id!="" && formik.values?.company_id!=null) && <><div>
                            <label
                                htmlFor="machines"
                                className="block text-md font-semibold text-gray-800"
                            >
                                Stroj*
                            </label>
                            <MultiSelect value={machineSelectValue} onChange={(e) => changeMachine(e.value)}
                                options={machineSelectOptions}
                                optionLabel="name"
                                dataKey="id"
                                filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            {formik.errors?.machines ? <span style={{color: "red"}}>{formik.errors?.machines}</span> : ""}
                        </div>
                        {formik.values?.machines?.length > 0 && <><div>
                            <label
                                htmlFor="lecturer_id"
                                className="block text-md font-semibold text-gray-800"
                            >
                            Lektor
                            </label>
                            <select required
                            name='lecturer_id'
                            onChange={(e) => changeLecturer(e.target.value)} value={formik.values?.lecturer_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_lektora')}</option>
                            {lecturers.map((lecturer) => (
                                <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                            ))}
                            </select>
                        </div>
                        {(formik.values?.lecturer_id!="" && formik.values?.lecturer_id!=null) && <><div>
                            <label
                                htmlFor="company_contact_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.Trainer')}</label>
                            <select required
                            name='company_contact_id'
                            onChange={formik.handleChange} value={formik.values?.company_contact_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_skolitela')}</option>
                            {companyContacts.map((contact) => (
                                <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                            ))}
                            </select>
                        </div>
                        {(formik.values?.company_contact_id!="" && formik.values?.company_contact_id!=null) &&<div>
                        <label
                            for="employees"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Zamestnanci
                        </label>
                        <MultiSelect required value={formik.values.employees} onChange={(e) => formik.setFieldValue("employees",e.value)}
                        options={recordEmployeeOptions(trainingCards, formik.values?.training_id, {
                            companyId: formik.values?.company_id,
                            machineIds: formik.values?.machines,
                            lecturerTypeId: formik.values?.lecturer_id,
                        })}
                        optionLabel="name"
                        dataKey="id"
                        filter placeholder={t('Common.SelectEmployees')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        {formik.errors.employees ? <div className="whitespace-pre-line" style={{color:'red'}}>{formik.errors.employees}</div> : null}
                        <div>
                            <label className="block text-md my-2 font-semibold text-gray-800">POČET: {formik.values.employees.length}</label>
                        </div>
                        </div>}</>}</>} </>}
                        <div>
                        <label
                            htmlFor="files"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Protokol
                        </label>
                          <input required
                          accept='image/*,application/pdf'
                          name='files'
                          ref={fileListRef}
                          onChange={handleFileChange}
                          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                          type='file'
                          multiple="multiple"
                          id='file'/>
                        </div>
                        <button type='submit' ref={submitRef}></button>
            </div>
            </div>
            </div>
             </form>
            </div>
        )}
            </>
            );

}